import { gql } from "@apollo/client";

const PREVIEW_MESSAGE_CONTACT_FIELDS = gql`
  fragment PreviewMessageContactFields on PreviewMessageContact {
    id
    name
    phoneNumber
  }
`;

export const LIST_PREVIEW_MESSAGE_CONTACTS = gql`
  ${PREVIEW_MESSAGE_CONTACT_FIELDS}
  query listPreviewMessageContacts($input: PreviewMessageContactsInput!) {
    previewMessageContacts(input: $input) {
      ...PreviewMessageContactFields
    }
  }
`;

export const CREATE_PREVIEW_MESSAGE_CONTACT = gql`
  ${PREVIEW_MESSAGE_CONTACT_FIELDS}
  mutation createPreviewMessageContact(
    $input: CreatePreviewMessageContactInput!
  ) {
    createPreviewMessageContact(input: $input) {
      ...PreviewMessageContactFields
    }
  }
`;

export const DELETE_PREVIEW_MESSAGE_CONTACT = gql`
  mutation deletePreviewMessageContact(
    $input: DeletePreviewMessageContactInput!
  ) {
    deletePreviewMessageContact(input: $input)
  }
`;

export const SEND_PREVIEW_MESSAGES = gql`
  mutation sendPreviewMessages($input: SendPreviewMessagesInput!) {
    sendPreviewMessages(input: $input) {
      nSent
      errors {
        message
        previewMessageContactName
        previewMessageContactPhoneNumber
      }
    }
  }
`;
